import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import moment from "moment";

import db from "../../firebase/_index";
import { doc, setDoc } from 'firebase/firestore'

export const appReducer = createSlice({
  name: "appReducer",

  initialState: {
    data: {
      username: "",
      name: "",
      typeUser: "",

      student: {
        welcomeTitle:
          `
            <p>Bạn có tò mò <strong><i>mình là ai</strong></i> trong 16 nhóm tính cách?</p> <br />
            <p>Hãy là chính mình và thành thật trả lời các câu hỏi dưới đây trong 5s đầu tiên nhé! </p> <br />
            <p>Chỉ chọn 1 đáp án và không bấm F5 trong quá trình trả lời.</p> <br />
            <p>Bạn đã sẵn sàng chưa? - Sẵn sàng</p>
          `,
        question: [
          {
            id: 1,
            title: `<p>Trong những cuộc trò chuyện thì <span id="name">{data.name}</span> là người:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p><strong>Nói nhiều hơn</strong> là nghe người khác nói.</p>",
              },
              {
                value: "b",
                title: "<p><strong>Lắng nghe</strong> người khác nhiều<strong> hơn</strong> là nói.</p>",
              },
            ]
          },
          {
            id: 2,
            title: `<p>Khi nhìn vào một vấn đề hoặc một sự việc thì <span id="name">{data.name}</span> sẽ:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p>Chú ý <strong>tiểu tiết</strong>.</p>",
              },
              {
                value: "b",
                title: "<p>Chú ý <strong>toàn cảnh</strong> và <strong>những việc có thể xảy ra.</strong></p>",
              },
            ]
          },
          {
            id: 3,
            title: `<p>Nếu mô tả về mình, <span id="name">{data.name}</span> là người:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p>Quyết định mọi việc rất <strong>khách quan.</strong></p>",
              },
              {
                value: "b",
                title: "<p>Quyết định mọi việc theo <strong>giá trị riêng</strong> và <strong>cảm nhận của bản thân.</strong></p>",
              },
            ]
          },
          {
            id: 4,
            title: `<p>Khi có kế hoạch thì <span id="name">{data.name}</span> sẽ:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p><strong>Thực hiện đúng</strong> kế hoạch đặt ra và <strong>không muốn thay đổi.</strong></p>",
              },
              {
                value: "b",
                title: "<p><strong>Linh hoạt</strong> khi thực hiện các kế hoạch.</p>",
              },
            ]
          },
          {
            id: 5,
            title: `<p>Trong những buổi họp mặt hay tranh luận cùng bạn bè, <span id="name">{data.name}</span> sẽ thường là:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p><strong>Tâm điểm</strong> của sự chú ý.</strong></p>",
              },
              {
                value: "b",
                title: "<p>Cảm thấy thoải mái khi <strong>ở một mình.</strong></p>",
              },
            ]
          },
          {
            id: 6,
            title: `<p>Trong những buổi họp mặt hay tranh luận cùng bạn bè, <span id="name">{data.name}</span> …thường sẽ thích:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p>Những giải pháp <strong>thực tế.</strong></p>",
              },
              {
                value: "b",
                title: "<p>Những ý tưởng <strong>sáng tạo.</strong></p>",
              },
            ]
          },
          {
            id: 7,
            title: `<p>Trong những buổi họp mặt hay tranh luận cùng bạn bè, <span id="name">{data.name}</span> sẽ có xu hướng:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p>Thường <strong>tranh luận</strong> cho vui.</p>",
              },
              {
                value: "b",
                title: "<p>Cố gắng <strong>tránh</strong> tất cả <strong>tranh luận và đối đầu.</strong></p>",
              },
            ]
          },
          {
            id: 8,
            title: `<p>Trong những buổi họp mặt hay tranh luận cùng bạn bè, <span id="name">{data.name}</span> ... :</p>`,
            answerList: [
              {
                value: "a",
                title: "<p>Rất <strong>chú trọng đến thời gian</strong> và luôn <strong>đúng giờ.</strong></p>",
              },
              {
                value: "b",
                title: "<p><strong>Ít quan tâm đến thời gian</strong> và <strong>thường trễ hẹn.</strong></p>",
              },
            ]
          },
          {
            id: 9,
            title: `<p><span id="name">{data.name}</span> sẽ có xu hướng:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p><strong>Hành động trước</strong> khi suy nghĩ.</p>",
              },
              {
                value: "b",
                title: "<p><strong>Suy nghĩ</strong> thật “chín” <strong>trước</strong> khi hành động.</p>",
              },
            ]
          },
          {
            id: 10,
            title: `<p>Quan điểm sống của <span id="name">{data.name}</span> là:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p>Chỉ tin vào <strong>kinh nghiệm thực tế.</strong></p>",
              },
              {
                value: "b",
                title: "<p>Chỉ tin vào <strong>bản năng</strong> mà thôi.</p>",
              },
            ]
          },
          {
            id: 11,
            title: `<p>Quan điểm sống của <span id="name">{data.name}</span> sẽ xem trọng:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p><strong>Tính trung thực</strong> và <strong>công bằng.</strong></p>",
              },
              {
                value: "b",
                title: "<p><strong>Sự hòa thuận</strong> và <strong>tình thương.</strong></p>",
              },
            ]
          },
          {
            id: 12,
            title: `<p>Quan điểm sống của <span id="name">{data.name}</span> là:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p><strong>Làm việc</strong> trước, <strong>chơi sau.</strong></p>",
              },
              {
                value: "b",
                title: "<p><strong>Chơi trước</strong> và <strong>làm</strong> việc <strong>sau.</strong></p>",
              },
            ]
          },
          {
            id: 13,
            title: `<p>Trong công việc, <span id="name">{data.name}</span> thích:</p>`,
            answerList: [
              {
                value: "a",
                title: `<p><strong>"Đóng vai chính".</strong></p>`,
              },
              {
                value: "b",
                title: `<p><strong>"Ẩn mình"</strong> sau <strong>"hậu trường".</strong></p>`,
              },
            ]
          },
          {
            id: 14,
            title: `<p>Trong công việc, <span id="name">{data.name}</span> sẽ:</p>`,
            answerList: [
              {
                value: "a",
                title: `<p>Chú ý <strong>mọi chi tiết</strong> và <strong>nhớ tất cả sự việc.</strong></p>`,
              },
              {
                value: "b",
                title: `<p>Chỉ chú ý những <strong>điều mới lạ.</strong></p>`,
              },
            ]
          },
          {
            id: 15,
            title: `<p>Trong công việc, với <span id="name">{data.name}</span> thì:</p>`,
            answerList: [
              {
                value: "a",
                title: `<p><strong>Nguồn động viên</strong> chính là thành tích đạt được.</p>`,
              },
              {
                value: "b",
                title: `<p>Cảm thấy “ấm lòng” vì sự <strong>công nhận</strong> của sếp.</p>`,
              },
            ]
          },
          {
            id: 16,
            title: `<p>Trong công việc, với <span id="name">{data.name}</span> thì việc ra quyết định:</p>`,
            answerList: [
              {
                value: "a",
                title: `<p>Khá <strong>dễ dàng.</strong></p>`,
              },
              {
                value: "b",
                title: `<p>Có thể khá <strong>khó khăn.</strong></p>`,
              },
            ]
          },
          {
            id: 17,
            title: `<p>Nhìn chung <span id="name">{data.name}</span> có khuynh hướng:</p>`,
            answerList: [
              {
                value: "a",
                title: `<p><strong>Thoải mái</strong> và <strong>nhiệt tình</strong></p>`,
              },
              {
                value: "b",
                title: `<p><strong>Độc lập</strong> và <strong>kín đáo.</strong></p>`,
              },
            ]
          },
          {
            id: 18,
            title: `<p>Nhìn chung <span id="name">{data.name}</span> có khuynh hướng:</p>`,
            answerList: [
              {
                value: "a",
                title: `<p>Có óc <strong>thực tế</strong> - thấy điều <strong>cụ thể</strong> trước mắt. </p>`,
              },
              {
                value: "b",
                title: `<p>Có óc <strong>sáng tạo</strong> - thấy điều <strong>có thể làm được.</strong></p>`,
              },
            ]
          },
          {
            id: 19,
            title: `<p><span id="name">{data.name}</span> sẽ bị thuyết phục bởi:</p>`,
            answerList: [
              {
                value: "a",
                title: `<p>Những <strong>lập luận có lý.</strong></p>`,
              },
              {
                value: "b",
                title: `<p><strong>Cảm giác</strong> của <strong>bản thân.</strong></p>`,
              },
            ]
          },
          {
            id: 20,
            title: `<p>Nhìn chung <span id="name">{data.name}</span> có khuynh hướng …:</p>`,
            answerList: [
              {
                value: "a",
                title: `<p>Chỉ cảm thấy <strong>thoải mái</strong> khi mọi việc đã <strong>có kế hoạch</strong> rõ ràng.</p>`,
              },
              {
                value: "b",
                title: `<p>Thích <strong>tự do</strong> và <strong>ứng biến</strong> tùy lúc.</p>`,
              },
            ]
          },
        ]
      },

      parrent: {
        welcomeTitle:
          `
          <p>Bạn có tò mò <strong><i>CON MÌNH sẽ là ai</i></strong> trong 16 nhóm tính cách?</p> <br />
          <p>Hãy đọc và suy nghĩ <strong>thật kĩ</strong> về <strong>con</strong> mình trước khi trả lời các câu hỏi dưới đây nhé!</p> <br />
          <p>Chỉ chọn 1 đáp án và không bấm F5 trong quá trình trả lời.</p> <br />
          <p>Bạn đã sẵn sàng chưa? - Sẵn sàng</p>
        `,
        question: [
          {
            id: 1,
            title: `<p>Trong những cuộc trò chuyện thì <span id="name">{data.name}</span> thấy bé là người:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p><strong>Nói nhiều hơn</strong> là nghe người khác nói.</p>",
              },
              {
                value: "b",
                title: "<p><strong>Lắng nghe</strong> người khác nhiều<strong> hơn</strong> là nói.</p>",
              },
            ]
          },
          {
            id: 2,
            title: `<p>Khi nhìn vào bức tranh thì <span id="name">{data.name}</span> nghĩ bé sẽ:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p>Chú ý <strong>tiểu tiết</strong>.</p>",
              },
              {
                value: "b",
                title: "<p>Chú ý <strong>toàn cảnh</strong> và <strong>những việc có thể xảy ra.</strong></p>",
              },
            ]
          },
          {
            id: 3,
            title: `<p><span id="name">{data.name}</span> thấy bé sẽ:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p>Quyết định mọi việc rất <strong>khách quan.</strong></p>",
              },
              {
                value: "b",
                title: "<p>Quyết định mọi việc theo <strong>giá trị riêng</strong> và <strong>cảm nhận của bản thân.</strong></p>",
              },
            ]
          },
          {
            id: 4,
            title: `<p><span id="name">{data.name}</span> nghĩ bé nếu có kế hoạch thì:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p>Con sẽ <strong>thực hiện đúng</strong> kế hoạch đặt ra và <strong>không muốn thay đổi.</strong></p>",
              },
              {
                value: "b",
                title: "<p>Con sẽ <strong>linh hoạt</strong> khi thực hiện các kế hoạch.</p>",
              },
            ]
          },
          {
            id: 5,
            title: `<p>Trong những buổi họp mặt hay tranh luận cùng bạn bè, <span id="name">{data.name}</span> bé sẽ thường là:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p><strong>Tâm điểm</strong> của sự chú ý.</strong></p>",
              },
              {
                value: "b",
                title: "<p>Cảm thấy thoải mái khi <strong>ở một mình.</strong></p>",
              },
            ]
          },
          {
            id: 6,
            title: `<p>Trong những buổi họp mặt hay tranh luận cùng bạn bè, <span id="name">{data.name}</span> …bé thường sẽ thích:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p>Những giải pháp <strong>thực tế.</strong></p>",
              },
              {
                value: "b",
                title: "<p>Những ý tưởng <strong>sáng tạo.</strong></p>",
              },
            ]
          },
          {
            id: 7,
            title: `<p>Trong những buổi họp mặt hay tranh luận cùng bạn bè, <span id="name">{data.name}</span> bé sẽ có xu hướng:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p>Thường <strong>tranh luận</strong> cho vui.</p>",
              },
              {
                value: "b",
                title: "<p>Cố gắng <strong>tránh</strong> tất cả <strong>tranh luận và đối đầu.</strong></p>",
              },
            ]
          },
          {
            id: 8,
            title: `<p>Trong những buổi họp mặt hay tranh luận cùng bạn bè, <span id="name">{data.name}</span> bé ... :</p>`,
            answerList: [
              {
                value: "a",
                title: "<p>Rất <strong>chú trọng đến thời gian</strong> và luôn <strong>đúng giờ.</strong></p>",
              },
              {
                value: "b",
                title: "<p><strong>Ít quan tâm đến thời gian</strong> và <strong>thường trễ hẹn.</strong></p>",
              },
            ]
          },
          {
            id: 9,
            title: `<p>Bé sẽ có xu hướng:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p><strong>Hành động trước</strong> khi suy nghĩ.</p>",
              },
              {
                value: "b",
                title: "<p><strong>Suy nghĩ</strong> thật “chín” <strong>trước</strong> khi hành động.</p>",
              },
            ]
          },
          {
            id: 10,
            title: `<p>Quan điểm sống của bé là:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p>Chỉ tin vào <strong>kinh nghiệm thực tế.</strong></p>",
              },
              {
                value: "b",
                title: "<p>Chỉ tin vào <strong>bản năng</strong> mà thôi.</p>",
              },
            ]
          },
          {
            id: 11,
            title: `<p><span id="name">{data.name}</span> nghĩ quan điểm sống của bé sẽ xem trọng:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p><strong>Tính trung thực</strong> và <strong>công bằng.</strong></p>",
              },
              {
                value: "b",
                title: "<p><strong>Sự hòa thuận</strong> và <strong>tình thương.</strong></p>",
              },
            ]
          },
          {
            id: 12,
            title: `<p>Bé sẽ là người:</p>`,
            answerList: [
              {
                value: "a",
                title: "<p><strong>Làm việc</strong> trước, <strong>chơi sau.</strong></p>",
              },
              {
                value: "b",
                title: "<p><strong>Chơi trước</strong> và <strong>làm</strong> việc <strong>sau.</strong></p>",
              },
            ]
          },
          {
            id: 13,
            title: `<p>Trong công việc, bé thích:</p>`,
            answerList: [
              {
                value: "a",
                title: `<p><strong>"Đóng vai chính".</strong></p>`,
              },
              {
                value: "b",
                title: `<p><strong>"Ẩn mình"</strong> sau <strong>"hậu trường".</strong></p>`,
              },
            ]
          },
          {
            id: 14,
            title: `<p>Trong công việc, bé sẽ:</p>`,
            answerList: [
              {
                value: "a",
                title: `<p>Chú ý <strong>mọi chi tiết</strong> và <strong>nhớ tất cả sự việc.</strong></p>`,
              },
              {
                value: "b",
                title: `<p>Chỉ chú ý những <strong>điều mới lạ.</strong></p>`,
              },
            ]
          },
          {
            id: 15,
            title: `<p>Trong công việc, <span id="name">{data.name}</span> nghĩ đối với bé thì:</p>`,
            answerList: [
              {
                value: "a",
                title: `<p><strong>Nguồn động viên</strong> chính là thành tích đạt được.</p>`,
              },
              {
                value: "b",
                title: `<p>Cảm thấy “ấm lòng” vì sự <strong>công nhận</strong> của sếp.</p>`,
              },
            ]
          },
          {
            id: 16,
            title: `<p><span id="name">{data.name}</span> nghĩ với bé thì việc ra quyết định:</p>`,
            answerList: [
              {
                value: "a",
                title: `<p>Khá <strong>dễ dàng.</strong></p>`,
              },
              {
                value: "b",
                title: `<p>Có thể khá <strong>khó khăn.</strong></p>`,
              },
            ]
          },
          {
            id: 17,
            title: `<p>Nhìn chung bé có khuynh hướng:</p>`,
            answerList: [
              {
                value: "a",
                title: `<p><strong>Thoải mái</strong> và <strong>nhiệt tình</strong></p>`,
              },
              {
                value: "b",
                title: `<p><strong>Độc lập</strong> và <strong>kín đáo.</strong></p>`,
              },
            ]
          },
          {
            id: 18,
            title: `<p><span id="name">{data.name}</span> thấy bé có khuynh hướng:</p>`,
            answerList: [
              {
                value: "a",
                title: `<p>Có óc <strong>thực tế</strong> - thấy điều <strong>cụ thể</strong> trước mắt. </p>`,
              },
              {
                value: "b",
                title: `<p>Có óc <strong>sáng tạo</strong> - thấy điều <strong>có thể làm được.</strong></p>`,
              },
            ]
          },
          {
            id: 19,
            title: `<p>Bé sẽ bị thuyết phục bởi:</p>`,
            answerList: [
              {
                value: "a",
                title: `<p>Những <strong>lập luận có lý.</strong></p>`,
              },
              {
                value: "b",
                title: `<p><strong>Cảm giác</strong> của <strong>bản thân.</strong></p>`,
              },
            ]
          },
          {
            id: 20,
            title: `<p>Nhìn chung bé có khuynh hướng là kiểu người:</p>`,
            answerList: [
              {
                value: "a",
                title: `<p>Chỉ cảm thấy <strong>thoải mái</strong> khi mọi việc đã <strong>có kế hoạch</strong> rõ ràng.</p>`,
              },
              {
                value: "b",
                title: `<p>Thích <strong>tự do</strong> và <strong>ứng biến</strong> tùy lúc.</p>`,
              },
            ]
          },
        ]
      },

      result: [
        {
          id: 1,
          answer: ""
        },
        {
          id: 2,
          answer: ""
        },
        {
          id: 3,
          answer: ""
        },
        {
          id: 4,
          answer: ""
        },
        {
          id: 5,
          answer: ""
        },
        {
          id: 6,
          answer: ""
        },
        {
          id: 7,
          answer: ""
        },
        {
          id: 8,
          answer: ""
        },
        {
          id: 9,
          answer: ""
        },
        {
          id: 10,
          answer: ""
        },
        {
          id: 11,
          answer: ""
        },
        {
          id: 12,
          answer: ""
        },
        {
          id: 13,
          answer: ""
        },
        {
          id: 14,
          answer: ""
        },
        {
          id: 15,
          answer: ""
        },
        {
          id: 16,
          answer: ""
        },
        {
          id: 17,
          answer: ""
        },
        {
          id: 18,
          answer: ""
        },
        {
          id: 19,
          answer: ""
        },
        {
          id: 20,
          answer: ""
        },
      ],

      user: {
        username: "",
        dob: "",
        phoneNumber: "",
        email: "",
        job: "Học sinh"
      },

      finalResult: "",
      finalResultString: "",
      motivationResult: "",
      motivationResultString: "",

      isntResult: [],

      isNotAnswerYet: false,
    }
  },

  reducers: {
    ONCHANGE_USERNAME: (state: any, actions: PayloadAction<any>) => {
      state.data.username = actions.payload
    },

    ONCHANGE_NAME_VIA_USERNAME: (state: any) => {
      let result = state.data.username.split(" ");
      sessionStorage.setItem("name", result[result.length - 1]);
      sessionStorage.setItem("fullname", state.data.username);
      state.data.name = result[result.length - 1];
    },

    ONCHANAGE_TYPE_OF_USER: (state: any) => {
      const urlLink = window.location.pathname;

      if (urlLink.includes("student")) {
        state.data.typeUser = "student";
        sessionStorage.setItem("type", "student");
      } else {
        sessionStorage.setItem("type", "parrent");
        state.data.typeUser = "parrent";
      }
    },

    ONCHANGE_ANSWER_LIST: (state: any, actions: PayloadAction<any>) => {
      state.data.result.forEach((item: any) => {
        if (item.id === actions.payload.id) {
          item.answer = actions.payload.value;
        }
      });
    },

    ONCHECK_HAS_ANSWERED_ALL: (state: any) => {
      state.data.isNotAnswerYet = false;
      state.data.isntResult = [];
      state.data.user.username = state.data.username;

      for (let i = 0; i < state.data.result.length; i++) {
        if (state.data.result[i].answer === "") {
          state.data.isNotAnswerYet = true;
          state.data.isntResult.push(i + 1);
        }
      }
    },

    ONCHANGE_INFO_USER: (state: any, actions: PayloadAction<any>) => {

      switch (actions.payload.type) {
        case "phoneNumber":
          if (actions.payload.value === "") {
            state.data.user.phoneNumber = ""
          } else {
            state.data.user.phoneNumber = "+84 " + actions.payload.value.toString();
          }
          break;
        case "email":
          if (actions.payload.value.includes("@")) {
            state.data.user.email = actions.payload.value;
          } else {
            state.data.user.email = "invalid";
          }
          break;
        case "dob":
          if (actions.payload.value === "") {
            state.data.user.dob = "invalid";
          } else {
            state.data.user.dob = actions.payload.value;
          }
          break;
        case "job":
          state.data.user.job = actions.payload.value;
          break;

        default:
          break;
      }
    },

    RESULT_SUBMIT: (state: any) => {

      sessionStorage.setItem("phoneNumber", state.data.user.phoneNumber)
      sessionStorage.setItem("email", state.data.user.email)
      sessionStorage.setItem("dob", state.data.user.dob)
      sessionStorage.setItem("job", state.data.user.job)

      let comparing = {
        firstCompare: {
          a: 0,
          b: 0
        },

        secondCompare: {
          a: 0,
          b: 0
        },

        thirdCompare: {
          a: 0,
          b: 0
        },

        fourthCompare: {
          a: 0,
          b: 0
        },
      }

      state.data.result.forEach((item: any, index: any) => {

        if (
          item.id === 1 ||
          item.id === 5 ||
          item.id === 9 ||
          item.id === 13 ||
          item.id === 17
        ) {
          if (item.answer === "a") {
            comparing.firstCompare.a++;
          } else {
            comparing.firstCompare.b++;
          }
        } else if (
          item.id === 2 ||
          item.id === 6 ||
          item.id === 10 ||
          item.id === 14 ||
          item.id === 18
        ) {
          if (item.answer === "a") {
            comparing.secondCompare.a++;
          } else {
            comparing.secondCompare.b++;
          }
        } else if (
          item.id === 3 ||
          item.id === 7 ||
          item.id === 11 ||
          item.id === 15 ||
          item.id === 19
        ) {
          if (item.answer === "a") {
            comparing.thirdCompare.a++;
          } else {
            comparing.thirdCompare.b++;
          }
        } else {
          if (item.answer === "a") {
            comparing.fourthCompare.a++;
          } else {
            comparing.fourthCompare.b++;
          }
        }
      });

      let firstWord: string = "";
      let secondWord: string = "";
      let thirdWord: string = "";
      let fourthWord: string = "";

      if (comparing.firstCompare.a > comparing.firstCompare.b) {
        firstWord = "E"
      } else {
        firstWord = "I"
      }

      if (comparing.secondCompare.a > comparing.secondCompare.b) {
        secondWord = "S"
      } else {
        secondWord = "N"
      }

      if (comparing.thirdCompare.a > comparing.thirdCompare.b) {
        thirdWord = "T"
      } else {
        thirdWord = "F"
      }

      if (comparing.fourthCompare.a > comparing.fourthCompare.b) {
        fourthWord = "J"
      } else {
        fourthWord = "P"
      }

      state.data.finalResult = firstWord + secondWord + thirdWord + fourthWord;

      sessionStorage.setItem("result", state.data.finalResult);

      switch (state.data.finalResult) {
        case "ENFJ":
          state.data.finalResultString = "NGƯỜI CHO ĐI"
          break;
        case "ENFP":
          state.data.finalResultString = "NGƯỜI TRUYỀN CẢM HỨNG"
          break;
        case "ENTJ":
          state.data.finalResultString = "NHÀ ĐIỀU HÀNH"
          break;
        case "ENTP":
          state.data.finalResultString = "NGƯỜI NHÌN XA TRÔNG RỘNG"
          break;
        case "ESFJ":
          state.data.finalResultString = "NGƯỜI CHĂM SÓC"
          break;
        case "ESFP":
          state.data.finalResultString = "NGƯỜI TRÌNH DIỄN"
          break;
        case "ESTJ":
          state.data.finalResultString = "NGƯỜI GIÁM HỘ"
          break;
        case "ESTP":
          state.data.finalResultString = "NGƯỜI NĂNG ĐỘNG"
          break;

        case "INFJ":
          state.data.finalResultString = "NGƯỜI CHE CHỞ"
          break;
        case "INFP":
          state.data.finalResultString = "NHÀ LÝ TƯỞNG HOÁ"
          break;
        case "INTJ":
          state.data.finalResultString = "NHÀ KHOA HỌC"
          break;
        case "INTP":
          state.data.finalResultString = "NHÀ TƯ DUY"
          break;
        case "ISFJ":
          state.data.finalResultString = "NGƯỜI CHĂM NOM"
          break;
        case "ISFP":
          state.data.finalResultString = "NGHỆ SĨ"
          break;
        case "ISTJ":
          state.data.finalResultString = "NGƯỜI TẬN TÂM VỚI CÔNG VIỆC"
          break;
        case "ISTP":
          state.data.finalResultString = "THỢ CƠ KHÍ"
          break;
      }

      sessionStorage.setItem("resultString", state.data.finalResultString);

      const numberOwner = state.data.user.dob.split("/");

      let firstNumber: number | undefined;
      let first1Number: number | undefined;
      let first2Number: number | undefined;

      let secondNumber: number | undefined;
      let second1Number: number | undefined;
      let second2Number: number | undefined;

      let thirdNumber: number | undefined;
      let third1Number: number | undefined;
      let third2Number: number | undefined;
      let third3Number: number | undefined;
      let third4Number: number | undefined;

      let finalNumber: number | undefined;

      numberOwner?.forEach((item: any, index: number) => {
        if (index === 0) {
          firstNumber = parseInt(numberOwner[index]);
        } else if (index === 1) {
          secondNumber = parseInt(numberOwner[index]);
        } else {
          thirdNumber = parseInt(numberOwner[index]);
        }
      })

      if (!!firstNumber && !!secondNumber && !!thirdNumber) {
        first1Number = Math.floor(firstNumber / 10);
        first2Number = firstNumber % 10;

        second1Number = Math.floor(secondNumber / 10);
        second2Number = secondNumber % 10;

        third1Number = Math.floor(thirdNumber / 1000);
        third2Number = Math.floor(thirdNumber / 100) % 10;
        third3Number = Math.floor(thirdNumber / 10) % 10;
        third4Number = Math.floor(thirdNumber / 1) % 10;

        finalNumber = first1Number + first2Number
          + second1Number + second2Number
          + third1Number + third2Number + third3Number + third4Number
      }

      let finalNumberOwner: string | undefined;

      if (finalNumber === 10) {
        finalNumberOwner = "10";
      } else if (finalNumber === 11) {
        finalNumberOwner = "11/2";
      } else if (finalNumber === 22) {
        finalNumberOwner = "22/4"
      } else if (!!finalNumber) {
        while (finalNumber > 10) {
          let firstNum: number = Math.floor(finalNumber / 10);
          let secondNum: number = first2Number = finalNumber % 10;

          finalNumber = firstNum + secondNum;
        }

        finalNumberOwner = finalNumber.toString();
      }

      state.data.motivationResult = finalNumberOwner;

      sessionStorage.setItem("motivation", state.data.motivationResult);

      switch (state.data.motivationResult) {
        case "2":
          state.data.motivationResultString = "TRỰC GIÁC";
          break;
        case "3":
          state.data.motivationResultString = "THÔNG MINH";
          break;
        case "4":
          state.data.motivationResultString = "THỰC TẾ";
          break;
        case "5":
          state.data.motivationResultString = "TỰ DO";
          break;
        case "6":
          state.data.motivationResultString = "SÁNG TẠO";
          break;
        case "7":
          state.data.motivationResultString = "TRẢI NGHIỆM";
          break;
        case "8":
          state.data.motivationResultString = "ĐỘC LẬP";
          break;
        case "9":
          state.data.motivationResultString = "HOÀI BÃO";
          break;
        case "10":
          state.data.motivationResultString = "THÍCH NGHI";
          break;
        case "11/2":
          state.data.motivationResultString = "TÂM LINH";
          break;
        case "22/4":
          state.data.motivationResultString = "TIỀM NĂNG";
          break;
      }

      sessionStorage.setItem("motivationString", state.data.motivationResultString);

      // NOTE: name taking
      let newStr: string | undefined = sessionStorage.getItem("fullname")?.normalize("NFD").replace(/[\u0300-\u036f]/g, "");    // Dont right with Đ, đ

      let tempArray: string[] = [];
      let tempCount: number = 0;

      if (newStr === undefined) {
        // Do nothing
      } else {
        for (let char of newStr) {
          tempArray.push(char);
        }
        tempArray.push(" ");
      }

      for (let i = 0; i < tempArray.length; i++) {
        if (
          tempArray[i] === "u" || tempArray[i] === "U" ||
          tempArray[i] === "e" || tempArray[i] === "E" ||
          tempArray[i] === "o" || tempArray[i] === "O" ||
          tempArray[i] === "a" || tempArray[i] === "A" ||
          tempArray[i] === "i" || tempArray[i] === "I"
        ) {
          tempCount++;
        } else if (tempArray[i] === "y" || tempArray[i] === "Y") {
          if (
            tempArray[i - 1] === "u" || tempArray[i - 1] === "U" ||
            tempArray[i - 1] === "e" || tempArray[i - 1] === "E" ||
            tempArray[i - 1] === "o" || tempArray[i - 1] === "O" ||
            tempArray[i - 1] === "a" || tempArray[i - 1] === "A" ||
            tempArray[i - 1] === "i" || tempArray[i - 1] === "I"
          ) {
            if (
              tempArray[i + 1] === "u" || tempArray[i + 1] === "U" ||
              tempArray[i + 1] === "e" || tempArray[i + 1] === "E" ||
              tempArray[i + 1] === "o" || tempArray[i + 1] === "O" ||
              tempArray[i + 1] === "a" || tempArray[i + 1] === "A" ||
              tempArray[i + 1] === "i" || tempArray[i + 1] === "I"
            ) {
              // Do nothing
            }
          } else {
            tempCount++;
          }
        }
      }

      while (tempCount > 11) {
        let first1Count = Math.floor(tempCount / 10);
        let first2Count = tempCount % 10;

        tempCount = first1Count + first2Count;
      }

      sessionStorage.setItem("namedOwner", tempCount.toString());

      let motivation: string | undefined;

      switch (tempCount) {
        case 1:
          motivation = "LÃNH ĐẠO";
          break;
        case 2:
          motivation = "YÊU THƯƠNG";
          break;
        case 3:
          motivation = "ẢNH HƯỞNG";
          break;
        case 4:
          motivation = "UY TÍN";
          break;
        case 5:
          motivation = "HÀI HƯỚC";
          break;
        case 6:
          motivation = "CHĂM SÓC";
          break;
        case 7:
          motivation = "TRẢI NGHIỆM";
          break;
        case 8:
          motivation = "THÀNH CÔNG";
          break;
        case 9:
          motivation = "CHO ĐI";
          break;
        case 10:
          motivation = "NHÂN ÁI";
          break;
        case 11:
          motivation = "TÂM LINH";
          break;
        default:
          motivation = "BÍ THUẬT";
          break;
      }

      sessionStorage.setItem("namedOwnerString", motivation);

      const date = new Date();
      const stringDate = moment(date).format('DD_MM_YYYY');

      const id = stringDate + "__" + sessionStorage.getItem("name");

      const body = {
        id: id,
        fullname: sessionStorage.getItem("fullname"),
        dob: sessionStorage.getItem("dob"),
        phoneNumber: sessionStorage.getItem("phoneNumber"),
        email: sessionStorage.getItem("email"),
        job: sessionStorage.getItem("job"),
        mbti: sessionStorage.getItem("result"),
        numberOwner: sessionStorage.getItem("motivation"),
        motivation: sessionStorage.getItem("namedOwner"),
        answerList: sessionStorage.getItem("answer"),
        createDate: new Date()
      }

      if (sessionStorage.getItem("type") === "student") {
        const docRef = doc(db, "học sinh", id)
        setDoc(docRef, {
          body
        })
      } else {
        const docRef = doc(db, "phụ huynh", id)
        setDoc(docRef, {
          body
        })
      }
    }
  }
});

export const {
  ONCHANGE_USERNAME,
  ONCHANGE_NAME_VIA_USERNAME,
  ONCHANAGE_TYPE_OF_USER,
  ONCHANGE_ANSWER_LIST,
  ONCHECK_HAS_ANSWERED_ALL,
  ONCHANGE_INFO_USER,
  RESULT_SUBMIT
} = appReducer.actions;

export default appReducer.reducer;
